import {
  Card,
  EHeadingStyleVariant,
  GeneralStarFillIcon,
  GeneralStarOutlineIcon,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';

import ClampedText from '@/components/switchback/ClampedText/ClampedText';
import { ILocalityRentalReview } from '@/services/getLocalityRentalReviews';

interface IReviewItemProps {
  review: ILocalityRentalReview;
}

export const ReviewItem: React.FC<IReviewItemProps> = ({ review }) => {
  const { id, reviewer, timestamp, score, text, rental_summary } = review;

  return (
    <Card
      key={id}
      withBoxShadow={false}
      className="justify-between flex-shrink-0 p-4 lg:p-6 h-[330px] lg:h-[300px] w-[265px] sm:flex-shrink border-[0.688px] border-gray-310 md:w-full md:max-w-[360px]">
      <Card.Content className="flex flex-col justify-between h-full gap-4">
        <div className="flex items-center justify-between">
          <Heading variant={EHeadingStyleVariant.H6}>
            {reviewer.first_name} {reviewer.last_name[0]}.
          </Heading>
          <Text className="text-gray-50">{dayjs(timestamp).format('MMMM, YYYY')}</Text>
        </div>
        <div className="flex gap-1">
          {Array.from({ length: 5 }, (_, index) => (
            <>
              {index < score ? (
                <GeneralStarFillIcon key={index} className="text-green-500" />
              ) : (
                <GeneralStarOutlineIcon key={index} className="text-green-500" />
              )}
            </>
          ))}
        </div>
        <div className="overflow-auto h-[106px] md:h-auto sm:h-[88px] md:min-h-[120px]">
          <ClampedText clamp={3} readMore readLess>
            {text}
          </ClampedText>
        </div>
        <div className="flex items-center gap-4 h-[72px] md:h-auto">
          <Link href={rental_summary.slug} target="_blank" className="flex items-center gap-4">
            <div className="flex items-center">
              <Image
                src={rental_summary.primary_image_url}
                alt={rental_summary.name}
                width={48}
                height={48}
                className="object-cover rounded-lg h-[48px] min-w-[48px]"
              />
            </div>
            <div className="flex items-center leading-snug line-clamp-2">{rental_summary.name}</div>
          </Link>
        </div>
      </Card.Content>
    </Card>
  );
};
